
<footer class="inner_f_i">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="inner_footer_social">
                    <ul>
                        <li>
                            <a href="javascript:void(0);">
                                <!-- <i class="fa fa-facebook-square" aria-hidden="true"></i> -->
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);">
                                <!-- <i class="fa fa-twitter-square" aria-hidden="true"></i> -->
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);">
                                <!-- <i class="fa fa-youtube-play" aria-hidden="true"></i> -->
                            </a>
                        </li>
                    </ul>

                    <div class="inner_app">                 
                        <div class="app_list">
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.digivive.platform8" class="w_play_store"></a>
                            <a target="_blank" href="https://apps.apple.com/in/app/platform8/id1565776465" class="w_app_store"></a>
                        </div>
                     </div>
                </div>
  
                <div class="inner_footer_page">
                    <ul>
                        <!-- <li>
                            <a href="javascript:void(0);"  routerLink="/advertise">
                                Advertise
                            </a>
                        </li> -->
                        <li>
                            <a href="javascript:void(0);" routerLink="/aboutus">
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);" routerLink="/terms">
                                Terms &  Use
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);" routerLink="/policy">
                                Privacy Policy
                            </a>
                        </li>
                        <!-- <li>
                            <a href="javascript:void(0);" routerLink="/faq">
                             FAQs
                            </a>
                        </li> -->
                        
                        <!-- <li>
                            <a href="javascript:void(0);" routerLink="/media">
                                Media
                            </a>
                        </li> -->
                        <li>
                            <a href="javascript:void(0);" routerLink="/contactus">
                                Contact Us
                            </a>
                        </li>
                        
                    </ul>
                </div>

                <!-- <span class="demo_c">This is demo website for testing purposes.</span> -->
  
                <p class="copy">&copy;  2021, Platform8 is an OTT platform run by Channel Eight Virtual Estudios Limited.</p>
            </div>
        </div>
    </div>        
  </footer>